export function getNameFirstDigits(name, withDots = false) {
    const namesArr = name.split(' ')
    let output = ''
    for (let i = 0; i < namesArr.length; i++) {
        output += `${String(namesArr[i])[0]}${withDots ? '.' : ''}`
    }

    return output
}